module.exports = __webpack_public_path__ + "img/modal_felicitacion_navidad.b836a25e.jpeg";